import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    badge: {
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      top: 0,
      marginTop: -6,
      marginRight: -10,
      right: 0,
      width: 22,
      height: 22,
      fontSize: 13,
      borderRadius: '50%',
      background: theme.palette.colors.yellow,
      color: theme.palette.colors.white,
    },
  }),
);

export default useStyles;
